import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.set";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import _regenerator from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
import _toConsumableArray from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatLstApi, attachmentCreateApi, attachmentUpdateApi, picNameEditApi, attachmentDeleteApi, attachmentListApi, picDeleteApi, categoryApi } from '@/api/system';
import { getToken } from '@/utils/auth';
import SettingMer from '@/libs/settingMer';
import uploadImg from '@/components/uploadImg';
export default {
  name: 'Upload',
  components: {
    uploadImg: uploadImg
  },
  props: {
    isMore: {
      type: String,
      default: '1'
    },
    setModel: {
      type: String
    },
    isIframe: {
      type: Boolean,
      default: false
    },
    isPage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      params: '',
      pids: '',
      treeId: 0,
      sleOptions: {
        attachment_category_name: '',
        attachment_category_id: ''
      },
      list: [],
      filterText: '',
      treeData: [],
      treeData2: [],
      defaultProps: {
        children: 'children',
        label: 'attachment_category_name'
      },
      classifyId: 0,
      myHeaders: {
        'X-Token': getToken()
      },
      tableData: {
        page: 1,
        pageSize: 30,
        attachment_category_id: 0,
        order: '',
        attachment_name: ''
      },
      pictrueList: {
        list: [],
        total: 0
      },
      isShowPic: false,
      checkPicList: [],
      ids: [],
      checkedMore: [],
      checkedAll: [],
      selectItem: [],
      editId: '',
      // 记录id
      editName: '',
      // 记录保存前名字
      lietStyle: 'list',
      isDialog: false
    };
  },
  computed: {
    fileUrl: function fileUrl() {
      return SettingMer.https + "/upload/image/".concat(this.tableData.attachment_category_id, "/file");
    }
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted: function mounted() {
    var that = this;
    this.params = this.$route && this.$route.path ? this.$route.path : '';
    if (this.$route && this.$route.query.field === 'dialog') {
      import("../../../public/UEditor/dialogs/internal");
    }
    this.getList();
    this.getFileList('');
    if (that.$route && that.$route.query.field || !that.$route) {
      that.isDialog = true;
    }
    if (that.$route && that.$route.query.field === 'dialog') {
      that.isDialog = true;
      form_create_helper.onOk(function () {
        that.checkPics();
      });
    }
  },
  methods: {
    radioChange: function radioChange() {
      this.initData();
    },
    initData: function initData() {
      // this.pids = 0;
      this.checkPicList = [];
      this.selectItem = [];
      this.ids = [];
      if (this.lietStyle === 'table') this.$refs.table.clearSelection();
      this.pictrueList.list.map(function (el, i) {
        el.isSelect = false;
        el.num = 0;
      });
    },
    getRowKey: function getRowKey(row) {
      return row.attachment_id;
    },
    //  选中某一行
    handleSelectRow: function handleSelectRow(selection) {
      this.ids = [];
      if (selection.length) {
        var arr = this.unique(selection);
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (!this.ids.includes(item.attachment_id)) {
            this.ids.push(item.attachment_id);
          }
        }
      }
    },
    // 对象数组去重；
    unique: function unique(arr) {
      var result = arr.reduce(function (acc, curr) {
        var x = acc.find(function (item) {
          return item.attachment_id === curr.attachment_id;
        });
        if (!x) {
          return acc.concat([curr]);
        } else {
          return acc;
        }
      }, []);
      return result;
    },
    lookImg: function lookImg(item) {
      var _this = this;
      this.imageUrl = item.attachment_src;
      var viewer = this.$el.querySelector('.images').$viewer;
      viewer.show();
      this.$nextTick(function () {
        var i = _this.pictrueList.list.findIndex(function (e) {
          return e.attachment_src === item.attachment_src;
        });
        viewer.update().view(i);
      });
    },
    // 搜索分类
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.attachment_category_name.indexOf(value) !== -1;
    },
    // 所有分类
    getList: function getList() {
      var _this2 = this;
      var data = {
        attachment_category_name: '全部图片',
        attachment_category_id: 0
      };
      formatLstApi().then(function (res) {
        _this2.treeData = res.data;
        _this2.treeData.unshift(data);
        _this2.treeData2 = _toConsumableArray(_this2.treeData);
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    // 编辑图片名称
    handleEdit: function handleEdit(item) {
      var _this3 = this;
      if (!item.attachment_name.trim()) {
        this.$message.warning('请先输入图片名称');
        return;
      }
      picNameEditApi(item.attachment_id, {
        attachment_name: item.attachment_name
      }).then(function (res) {
        item.isEdit = false;
        _this3.$message.success(res.message);
      }).catch(function (error) {
        _this3.$message.error(error.message);
      });
      // if(id === this.editId) {
      //   if(this.editName !== name) {
      //     if(!name.trim()) {
      //       this.$message.warning("请先输入图片名称");
      //       return;
      //     }
      //     picNameEditApi(id, {
      //       attachment_name: name
      //     }).then(() => this.getFileList(""));
      //     this.editId = "";
      //   } else {
      //     this.editId = "";
      //     this.editName = "";
      //   }
      // } else {
      //   this.editId = id;
      //   this.editName = name;
      // }
    },
    // 添加分类
    onAdd: function onAdd(id) {
      var _this4 = this;
      var config = {};
      if (Number(id) > 0) config.formData = {
        pid: id
      };
      this.$modalForm(attachmentCreateApi(), config).then(function (_ref) {
        var message = _ref.message;
        // this.$message.success(message)
        _this4.getList();
      });
    },
    // 编辑
    onEdit: function onEdit(id) {
      var _this5 = this;
      this.$modalForm(attachmentUpdateApi(id)).then(function () {
        return _this5.getList();
      });
    },
    // 删除
    handleDelete: function handleDelete(id) {
      var _this6 = this;
      this.$modalSure().then(function () {
        attachmentDeleteApi(id).then(function (_ref2) {
          var message = _ref2.message;
          _this6.$message.success(message);
          _this6.getList();
        }).catch(function (_ref3) {
          var message = _ref3.message;
          _this6.$message.error(message);
        });
      });
    },
    // 点击树
    appendBtn: function appendBtn(data) {
      this.treeId = data.attachment_category_id;
      this.tableData.attachment_category_id = data.attachment_category_id;
      this.selectItem = [];
      this.checkPicList = [];
      this.tableData.page = 1;
      this.getFileList();
    },
    handleNodeClick: function handleNodeClick(data) {
      this.treeId = tableData.attachment_category_id;
      this.tableData.attachment_category_id = data.attachment_category_id;
      this.selectItem = [];
      this.checkPicList = [];
      this.getFileList('');
    },
    // 点击上传
    uploadModal: function uploadModal() {
      this.$refs.upload.uploadModal = true;
    },
    uploadSuccess: function uploadSuccess() {
      this.tableData.page = 1;
      this.getFileList('');
    },
    enterMouse: function enterMouse(item) {
      item.realName = !item.realName;
    },
    enterLeave: function enterLeave(item) {
      item.isShowEdit = !item.isShowEdit;
    },
    // 点击菜单
    clickMenu: function clickMenu(data, name) {
      if (name === 1) {
        this.onAdd(data.attachment_category_id);
      } else if (name === 2) {
        this.onEdit(data.attachment_category_id);
      } else if (name === 3) {
        this.handleDelete(data.attachment_category_id);
      }
    },
    // 上传成功
    handleSuccess: function handleSuccess(response) {
      if (response.status === 200) {
        this.$message.success('上传成功');
        this.getFileList('');
      } else {
        this.$message.error(response.message);
      }
    },
    // 文件列表
    getFileList: function getFileList(num) {
      var _this7 = this;
      this.loading = true;
      this.tableData.page = num || this.tableData.page;
      attachmentListApi(this.tableData).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                res.data.list.forEach(function (el) {
                  el.isSelect = false;
                  el.isEdit = false;
                  el.isShowEdit = false;
                  el.realName = false;
                  el.num = 0;
                });
                _this7.pictrueList.list = res.data.list;
                if (_this7.pictrueList.list.length) {
                  _this7.isShowPic = false;
                } else {
                  _this7.isShowPic = true;
                }
                if (_this7.$route && _this7.$route.query.field && _this7.$route.query.field !== 'dialog') {
                  _this7.checkedMore = window.form_create_helper.get(_this7.$route.query.field) || [];
                }
                _this7.pictrueList.total = res.data.total;
                _this7.loading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this7.$message.error(res.message);
        _this7.loading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableData.page = page;
      this.selectItem = [];
      this.checkPicList = [];
      this.getFileList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.getFileList('');
    },
    // 选中图片
    changImage: function changImage(item, index, row) {
      var _this8 = this;
      if (!item.isSelect) {
        item.isSelect = true;
        this.selectItem.push(item);
        this.checkPicList.push(item.attachment_src);
        this.ids.push(item.attachment_id);
      } else {
        item.isSelect = false;
        var index = this.ids.indexOf(item.attachment_id);
        if (index > -1) this.ids.splice(index, 1);
        this.selectItem.forEach(function (o, i) {
          if (o.attachment_id === item.attachment_id) {
            _this8.selectItem.splice(i, 1);
          }
        });
        this.checkPicList.map(function (el, index) {
          if (el === item.attachment_src) {
            _this8.checkPicList.splice(index, 1);
          }
        });
      }
      // if (
      //   (this.$route &&
      //     this.$route.fullPath &&
      //     this.$route.fullPath !== "/admin/config/picture") ||
      //   !this.$route
      // ) {
      this.pictrueList.list.map(function (el, i) {
        if (el.isSelect) {
          _this8.selectItem.filter(function (el2, j) {
            if (el.attachment_id === el2.attachment_id) {
              el.num = j + 1;
            }
          });
        } else {
          el.num = 0;
        }
      });
      // }
    },
    // 点击使用选中图片
    checkPics: function checkPics(isButton) {
      if (this.checkPicList.length) {
        if (this.$route) {
          if (this.$route.query.type === '1') {
            if (this.checkPicList.length > 1) {
              return this.$message.warning('最多只能选一张图片');
            }
            /* eslint-disable */
            form_create_helper.set(this.$route.query.field, this.checkPicList[0]);
            if (isButton) form_create_helper.close(this.$route.query.field);
          }
          if (this.$route.query.type === '2') {
            this.checkedAll = [].concat(_toConsumableArray(this.checkedMore), _toConsumableArray(this.checkPicList));
            form_create_helper.set(this.$route.query.field, Array.from(new Set(this.checkedAll)));
            form_create_helper.close(this.$route.query.field);
          }
          if (this.$route.query.field === 'dialog') {
            var str = '';
            for (var i = 0; i < this.checkPicList.length; i++) {
              str += '<img src="' + this.checkPicList[i] + '">';
            }
            /* eslint-disable */
            nowEditor.editor.execCommand('insertHtml', str);
            nowEditor.dialog.close(true);
          }
          this.$emit('getImage', this.checkPicList);
        } else {
          if (this.isMore === '1' && this.checkPicList.length > 1) {
            return this.$message.warning('最多只能选一张图片');
          }
          this.$emit('getImage', this.checkPicList);
        }
      } else {
        this.$message.warning('请先选择图片');
      }
    },
    // 单个删除
    deletePic: function deletePic(item) {
      this.ids = [item.attachment_id];
      this.deletePicList();
    },
    // 删除图片
    deletePicList: function deletePicList(tit) {
      var _this9 = this;
      var ids = {
        ids: this.ids
      };
      this.$confirm('确定删除图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        picDeleteApi(ids).then(function (_ref5) {
          var message = _ref5.message;
          _this9.$message.success(message);
          _this9.getFileList('');
          _this9.spliceDeleteList();
          _this9.initData();
        }).catch(function (_ref6) {
          var message = _ref6.message;
          _this9.$message.error(message);
        });
      }).catch(function () {
        _this9.$message({
          type: 'info',
          message: '已取消'
        });
        _this9.initData();
      });
    },
    // 去除选中数组中删除掉的元素
    spliceDeleteList: function spliceDeleteList() {
      var _this0 = this;
      this.selectItem.map(function (el, i) {
        _this0.ids.filter(function (el2, j) {
          if (el.attachment_id === el2) {
            _this0.selectItem.splice(i, 1);
          }
        });
      });
    },
    // 移动分类点击
    handleSelClick: function handleSelClick(status) {
      if (!status) {
        this.getMove();
      } else {
        if (!this.ids.toString()) {
          this.$message.warning('请先选择图片');
          return;
        }
      }
    },
    getMove: function getMove() {
      var _this1 = this;
      var data = {
        pid: this.pids,
        images: this.ids.toString()
      };
      if (!data.images) return;
      if (this.pids === '') {
        this.$message.warning('请选择分类');
        return;
      }
      categoryApi(this.ids, this.pids).then(/*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this1.$message.success(res.message);
                _this1.pids = '';
                _this1.initData();
                _this1.getFileList('');
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref7.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this1.pids = '';
        _this1.initData();
        _this1.$message.error(res.message);
      });
    }
  }
};